var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturnPopupIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "139px",
    width: "139px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.00 512.00",
    xmlSpace: "preserve",
    fill: "#000000",
    transform: "matrix(1, 0, 0, 1, 0, 0) rotate(0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 4.096
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD54"
    },
    d: "M10,256.006C10,398.003,115.557,502.556,255.996,502C396.453,502.556,502,398.003,502,256.006 C502.556,115.557,396.453,10,255.996,10C115.557,10,10,115.557,10,256.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F6F9"
    },
    d: "M336.147,192.37H127.529l58.63-58.63c2.762-2.762,2.762-7.235,0-9.997 c-2.762-2.762-7.235-2.762-9.997,0l-70.7,70.7c-2.762,2.762-2.762,7.235,0,9.997l70.7,70.7c1.381,1.381,3.189,2.071,4.998,2.071 s3.618-0.69,4.998-2.071c2.762-2.762,2.762-7.235,0-9.997l-58.63-58.63h208.619c43.186,0,78.321,38.06,78.321,84.839 s-35.136,84.84-78.321,84.84H273.07c-3.908,0-7.07,3.166-7.07,7.07c0,3.904,3.163,7.07,7.07,7.07h63.077 c50.981,0,92.462-44.401,92.462-98.979S387.128,192.37,336.147,192.37z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnPopupIcon);
export default __webpack_public_path__ + "static/media/ReturnPopupIcon.865ce14e040fe6f1257fc76f2a727e6d.svg";
export { ForwardRef as ReactComponent };